import { createContext } from 'react';
// export type WidgetContextValues<W extends IWidget> = Control<W>;
export const BaseWidgetContext = createContext({});
const WidgetContext = createContext({});
export default WidgetContext;
